import '../css/page.css';
import { Col, Container, Row } from 'react-bootstrap'
import InfoButton from '../components/infobutton';

function Page7() {
  if (window.innerWidth > 714) {
    return (
      <div className='ContentWrapper' style={{ display: 'flex', height: '90vh', background: 'transparent' }}>
        <div style={{ width: '75%', padding: '3rem', justifyContent: 'left', paddingTop: '8rem' }}>
          <div className='BlockWrapper' style={{ height: 'auto', alignItems: 'start', justifyContent: 'left', padding: '2em', display: 'flex', flexDirection: 'column' }}>
            <Container>
              <Col md={12}>
                <Row>
                  <h1 className='MegaPageHeading' style={{ margin: 'none', paddingTop: '0rem', textAlign: 'left', wordBreak: 'normal', fontSize: 'clamp(2rem, 5vw, 6.8rem)' }}>Ready to take your next step with confidence?</h1>
                </Row>
                <Row style={{ paddingTop: '3rem', paddingLeft: '1rem' }}>
                  <InfoButton />
                </Row>
              </Col>
              <Col md={12}/>
            </Container>
          </div>
        </div>
      </div>
    );
  } else {
    return (
      <div className='ContentWrapper' style={{ display: 'flex', height: 'auto', background: 'transparent', justifyContent: 'center', alignItems: 'center', paddingTop: '4rem', paddingBottom: '4rem' }}>
        <div className='BlockWrapper' style={{ height: '85%', width: '85%', alignItems: 'start', justifyContent: 'left', padding: '1.5rem', display: 'flex' }}>
          <Container>
            <Col md={12}>
              <Row>
                <h1 className='MegaPageHeading' style={{ margin: 'none', paddingTop: '0rem', textAlign: 'left', wordBreak: 'normal', fontSize: 'clamp(2rem, 5vw, 6.8rem)' }}>Ready to take your next step with confidence?</h1>
              </Row>
              <Row style={{ paddingTop: '3rem', paddingLeft: '1rem' }}>
                <InfoButton />
              </Row>
            </Col>
            <Col md={12}/>
          </Container>
        </div>
      </div>
    );
  }
}

export default Page7;

// TODO: A page specifically for more detailed features, the comparison feature
// take your next step with confidence